import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { NativeProps, withNativeProps } from '../utils/native-props';
import CheckListContext from './context';
import { devWarning } from '../utils/dev-log';
import styles from './check-list.module.scss';

export type CheckListItemProps = {
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
} & NativeProps;

export const CheckListItem: FC<CheckListItemProps> = (props) => {
  const context = useContext(CheckListContext);
  if (context === null) {
    devWarning('CheckList.Item', 'CheckList.Item can only be used inside CheckList.');
    return null;
  }
  const active = context.value.includes(props.value);
  const readOnly = props.readOnly || context.readOnly;
  const disabled = props.disabled || context.disabled;
  const content = (
    <div
      className={styles.item_content}
      onClick={(e) => {
        if (readOnly || disabled) return;
        if (active) {
          context.uncheck(props.value);
        } else {
          context.check(props.value);
        }
        props.onClick?.(e);
      }}
    >
      {!disabled && active && <img className={styles.item_content_icon} src='https://i9.taou.com/maimai/p/30644/335_6_17kawZntGqB01I' />}
      {!disabled && !active && <img className={styles.item_content_icon} src='https://i9.taou.com/maimai/p/30644/334_6_o2PiBqHzJ5CjHC' />}
      {disabled && <img className={styles.item_content_icon} src='https://i9.taou.com/maimai/p/30644/333_6_81GUgSTwxDBZlopM' />}
      <div className={styles.item_content_main}>{props.children}</div>
    </div>
  );
  return withNativeProps(
    props,
    React.createElement(
      'div',
      {
        className: classNames(styles.item, props.disabled && styles.item_disabled),
        onClick: props.disabled ? undefined : props.onClick,
      },
      content
    )
  );
};
